<div class="file-upload-display mt-3">
  <div class="d-flex align-items-center">
    <div class="upload-filename mr-auto">{{ fileInfo.name }}</div>
    <ng-container *ngIf="fileInfo.isUploading; else uploadFinished">
      <div *ngIf="fileInfo.progressBarMode === 'determinate'" class="mr-2">
        {{ fileInfo.uploadProgress }}%
      </div>
      <div *ngIf="fileInfo.progressBarMode === 'indeterminate'" class="mr-2">
        Processing
      </div>
    </ng-container>
    <ng-template #uploadFinished>
      <div class="text-success mr-2" *ngIf="fileInfo.isSuccess">
        Upload successful
      </div>
    </ng-template>
  </div>
  <div class="progress-bar-row d-flex align-items-center">
    <mat-progress-bar
      class="progress-bar"
      [ngClass]="{ 'upload-success': fileInfo.isSuccess }"
      [color]="fileInfo.progressBarColor"
      [mode]="fileInfo.progressBarMode"
      [value]="fileInfo.uploadProgress"
    ></mat-progress-bar>
    <button
      id="remove-file-btn"
      type="button"
      (click)="handleFileRemoval(fileInfo)"
      mat-icon-button
      class="cancel-icon"
      [hidden]="fileInfo.isSuccess"
      tabIndex="0"
    >
      <span class="material-icons">highlight_off</span>
    </button>
  </div>
  <div class="row">
    <div class="col upload-message">
      <span class="text-danger" *ngIf="fileInfo.error.onUpload">{{
        fileInfo.error.onUpload
      }}</span>
      <span class="text-danger" *ngIf="fileInfo.error.fileSize">{{
        fileInfo.error.fileSize
      }}</span>
      <span class="text-danger" *ngIf="fileInfo.error.fileType">{{
        fileInfo.error.fileType
      }}</span>
      <span class="text-danger" *ngIf="fileInfo.error.fileAmount">{{
        fileInfo.error.fileAmount
      }}</span>
    </div>
  </div>
</div>
